import styled from 'styled-components';
import { Collapse } from 'antd';
import metrics from '../../styles/metrics';

const { Panel } = Collapse;

export const Caixa = styled(Panel)`
  margin-bottom: ${metrics.baseMargin};
`;
